var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "tw-w-screen tw-h-screen tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4",
    },
    [
      _c("BaseLoader", { staticClass: "tw-w-16 tw-h-16" }),
      _vm._v(" "),
      _c("p", { staticClass: "tw-bold tw-text-grey-dark" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.$t("logging_out")) + "\n\t"),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }